import React, {useEffect, useState} from 'react';
import Banner from "../../../../../assets/images/BreachRisk_Data_Sharing.svg";
import {useDispatch, useSelector} from "react-redux";
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import {
    fetchBRBusinessShares,
} from "../../../../../actions";
import BRBusinessSharingTable
    from "../../../../../components/customBreachBits/BreachRiskSharing/BRBusinessSharingTable";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { makeStyles } from '@material-ui/core/styles';
import {withStyles} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import VerifiedOwnershipRequiredDialog
    from "../../../../../components/customBreachBits/OnboardingProgress/VerifiedOwnershipRequiredDialog";

const useStyles = makeStyles(theme=> ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
        // filter: `blur(3px)`,

    },
}))

// const CustomAccordion = withStyles((theme)=>({
//     border: `1px solid ${theme.palette.divider}`,
//     '&:not(:last-child)': {
//         borderBottom: 0,
//     },
//     '&:before': {
//         display: 'none',
//     },
//     backgroundColor: "rgba(255, 255, 255, 0.25)",
//
//     flexDirection: 'row-reverse',
//     '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
//         transform: 'rotate(90deg)',
//     },
//     '& .MuiAccordionSummary-content': {
//         marginLeft: theme.spacing(1),
//     },
//
// }))(Accordion)

// const style = {
//     border: `1px solid `,
//     '&:not(:last-child)': {
//         borderBottom: 0,
//     },
//     '&:before': {
//         display: 'none',
//     },
// }


const Dashboard= (props) => {

    const {customers, customerInView} = useSelector(({customer}) => customer);
    // const customer = customers ? customers[customerInView] : null;
    const {authUser} = useSelector(({auth}) => auth);
    // console.log("current shares. authUser is", authUser);

    const [expanded, setExpanded] = useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };

    const dispatch = useDispatch();

    const {portfolios, loadingPortfolios, loadingBRBusinessShares} = useSelector(({breachrisk}) => breachrisk);

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;
    // const myEntity = portfolios ? portfolios[customerIdToUse] ? portfolios[customerIdToUse].entities ? selfEntityId ? portfolios[customerIdToUse].entities[selfEntityId] : null : null : null : null;
    // const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);


    useEffect(() => {


        /*  jfd*******************************
                 *   Fetch current shares if needed
                     ********************************** */
        //TODO: add logic so this is only done if this is a BRBusiness customer?

        // console.log("Checking to see if should fetch shares", "portfolios", portfolios, myEntity, "loading?", loadingBRBusinessShares);
        if (
            portfolios
            && customerIdToUse
            && authUser
            && portfolios[customerIdToUse]
            && !portfolios[customerIdToUse].shares
            && !loadingBRBusinessShares[customerIdToUse]
        ) {
            // console.log("Yes, fetching shares for entityId",entityInView);
            dispatch(fetchBRBusinessShares({
                // entityId: selfEntityId,
                customerId: customerIdToUse
            }));
        } else if (portfolios && portfolios[customerIdToUse] && portfolios[customerIdToUse].shares) {
            // console.log("No, shares already exist", portfolios[customerIdToUse].shares)
        } else {
            // console.log("No, don't fetch shares")
        }


    }, [dispatch, customers, customerInView, portfolios, loadingPortfolios, loadingBRBusinessShares, authUser, customerIdToUse]);
    // const customer = customers ? customers[customerInView] : null;

    return (
        // <MultiBoardWrapper customer={customer}>
        <div className="app-wrapper">
            <div className="animated fadeIn animation-duration-7">
          <div className="row">
              <div className={"col-8 align-self-center"}>
                  <div className={"mx-0 px-0"} id={"tourStopHeader"}>
                      <div style={{backgroundImage: `url(${Banner})`, margin: "auto", width: "auto", backgroundRepeat: "no-repeat", backgroundPosition: "left center", height: "60px"}}/>
                  </div>
              </div>
              <div className={"col-4 align-self-center"}>
                  <h3>The most secure companies share data. </h3>
                  <p>Sharing data with other companies, industry associations, investors, clients, and suppliers is an essential part of achieving a high level
                  of cybersecurity maturity. Use the sharing interface to share only the information you want, and keep it secure. You are always in control, and sharing can be
                  enabled and disabled whenever you need.</p>

              </div>
          </div>
          <hr/>
                <VerifiedOwnershipRequiredDialog>
                    <div className="row"  id={"tourReportRequestTable"}>

                        <div className="col-12">
                            <BRBusinessSharingTable removeApprovedActiveShares
                                                    removeSharesNotRequested
                                                    removeSharesNotActive
                                                    disableColumnSelector
                                                    disableDensitySelector
                                                    disableColumnMenu
                                                    disableColumnFilter
                                                    tableTipText={"Other companies can request access to your BreachRisk™ Report. All requests are displayed in this table, and can be approved here. You can revoke access at any time."}/>
                        </div>
                    </div>

                    <div className="row">

                        <div className="col-12" id={"tourActiveShareTable"}>
                            <BRBusinessSharingTable removePendingInactiveShares
                                                    showAddButton
                                                    disableColumnSelector
                                                    disableDensitySelector
                                                    disableColumnMenu
                                                    disableColumnFilter
                                                    tableTipText={"All companies that can actively view your BreachRisk™ Report are displayed in this table. These have all been approved by you and will remain active until you disable them."}/>
                        </div>
                    </div>
                    <hr/>

                    <div className="row" id={"tourPastShareTable"}>
                        <div className="col-12">
                            <Accordion expanded={expanded === "Archive"}
                                       onChange={handleChange("Archive")}
                                       elevation={1}
                                // sx={{
                                //     ...style,
                                // }}
                            >
                                <AccordionSummary expandIcon={<ExpandMoreIcon/>}>
                                    <h1 style={{ width: '33%', flexShrink: 0 }}>
                                        Archive of All
                                        Sharing Records
                                    </h1>
                                    <Typography style={{color:"grey", marginTop: ".5em",}}>
                                        All shares that are no longer active or were not approved are in this table.
                                    </Typography>
                                </AccordionSummary>

                                <div className="app-wrapper">
                                    <BRBusinessSharingTable verbose archivedOnly
                                                            disableColumnSelector
                                                            disableDensitySelector
                                                            disableColumnMenu
                                                            disableColumnFilter
                                    />

                                </div>
                            </Accordion>
                        </div>
                    </div>


</VerifiedOwnershipRequiredDialog>
      </div>
        </div>


    // </MultiBoardWrapper>
    )
}
export default Dashboard;